export default {
    daysOfWeek: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
    limit: "Gränsen nådd ({{limit}} max).",
    loading: "Laddar...",
    minLength: "Min. längd",
    months: [
        "Januari",
        "Februari",
        "Mars",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "Augusti",
        "September",
        "Oktober",
        "November",
        "December"
    ],
    notSelected: "Ingen vald",
    required: "Nödvändig",
    search: "Sök",
    dateFormat: 'yyyy-MM-dd'
}